import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 0,
  class: "opt"
}
const _hoisted_3 = { class: "btn-group" }

import {ViewCard} from "vue-waterfall-plugin-next/dist/types/types/waterfall";
import {onMounted, ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateCardView',
  props: {
    tc: {}
  },
  emits: ['onLoad'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit
const themePreview = ref()
onMounted(() => {
  themePreview.value.onload = () => emit('onLoad')
  if (themePreview.value.complete) emit('onLoad')
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {path:'/editor',query:{theme_id:_ctx.tc.theme_id,tags:_ctx.tc.tags}},
    class: "theme-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.tc.src,
        alt: _ctx.tc.src,
        ref_key: "themePreview",
        ref: themePreview
      }, null, 8, _hoisted_1),
      (_ctx.tc.theme_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_button, {
                type: "primary",
                block: ""
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("创建活动")
                ])),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})